import { SlotGameType1_21 } from '../SlotGameType1_21';

export class RainbowMagic21 extends SlotGameType1_21
{
}
